import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { LogiDashboardsViewModelComponent } from './logi-dashboards-view-model/logi-dashboards-view-model.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { Organization } from 'src/app/models/um/organization';
import { UserService } from 'src/app/services/user.service';

@Component({
  templateUrl: './admin-logi-dashboards.component.html',
  styleUrls: ['./admin-logi-dashboards.component.scss']
})
export class AdminLogiDashboardsComponent {

  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  rowData;
  advanceSearch;
  selectedRow;
  Statuslist: any = [];
  Programslist: any = [];
  GenSearchFieldsData: UntypedFormGroup;
  tempoperations: any[];
  isSettings: boolean = false;
  collapesedOrNot: Boolean = false;
  OrgDetail: Organization;
  constructor(public analyticsService: AnalyticsService,public commonService:CommonService,
                   private modalService: NgbModal,private userService:UserService)
  {
    this.GenSearchFieldsData = new UntypedFormGroup({
      DISPLAY_NAME: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      Program: new UntypedFormControl("")
    });
  }
  ngOnInit() {

    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }
    ];
    this.Programslist = [
      { "value": "", "label": "All" },
    ];

    this.DashboradGrid();
    this.getDashboardsDetails();
    this.getCurrentOrgDetails();
  }

  getCurrentOrgDetails()
  {
    if(this.Programslist==undefined || this.Programslist==null)
    {
      this.Programslist = [
        { "value": "-1", "label": "All" },
      ];
    }
    this.OrgDetail = this.commonService.getOrganizationObject(this.userService.getOrgCode()); 
    if(this.OrgDetail!=null)
    {
      if(this.OrgDetail.IST==true)
        {
          this.Programslist.push( { "value": "ist", "label": this.OrgDetail.IST_DISPLAY_NAME })
        }
        if(this.OrgDetail.EAP==true)
        {
          this.Programslist.push( { "value": "eap", "label": this.OrgDetail.EAP_DISPLAY_NAME  })
        }
        if(this.OrgDetail.GRANTS==true)
        {
          if(this.OrgDetail.CHARITY==true)
          { 
            this.Programslist.push( { "value": "Grant_Charitable", "label":  this.OrgDetail.CHARITY_DISPLAY_NAME })
          }
          if(this.OrgDetail.SPONSERSHIP==true)
          { 
            this.Programslist.push( { "value": "Grant_Sponsorship", "label": this.OrgDetail.SPONSERSHIP_DISPLAY_NAME })
          }
          if(this.OrgDetail.CME==true)
          { 
            this.Programslist.push( { "value": "Grant_CME", "label": this.OrgDetail.CME_DISPLAY_NAME})
          }
        }
    }
  }
  

  getDashboardsDetails() {
    this.analyticsService.getDashboardsDetails(this.GenSearchFieldsData.value).subscribe(result => {
      if (result != null && result != undefined && result.length > 0) {
        this.rowData = result;
      } else {
        this.rowData = [];
      }
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      });
    });
  }


  DashboradGrid() {

    this.columnDefs = [
      {
        "headerName": "Dashboard Name",
        "field": "DASHBOARD_NAME"
      },
      {
        "headerName": "Dashboard Display Name",
        "field": "DISPLAY_NAME"
      },
      {
        "headerName": "Program",
        "field": "ProgramExt"
      },
      {
        "headerName": "Status",
        "field": "RecordStatus",
        valueGetter: RecordState
      }
    ];

    this.isSettings = true;
    this.tempoperations = [];
    this.tempoperations.push({
      "name": "Edit",
      "id": "Edit"
    });

    this.operations = this.tempoperations.map(operation => {
      return (operation && operation.id === 'Edit' ? { name: operation.name, callback: this.Edit, self: this, disabled: 'false' } : '')
    });

    this.advanceSearch = {
      "fields": [
        {
          "label": "Dashboard Display Name",
          "field": "DISPLAY_NAME",
          "type": "text"
        },
        {
          "label": "Status",
          "field": "Status",
          "type": "dropdown",
        }
      ]
    };

    function RecordState(params: any) {
      return params.data.RECORD_STATE == 1 ? "Active" : "Inactive";
    }
  }

  Edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(LogiDashboardsViewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: RecordData['ID'] }
    }
    modalRef.result.then(result=>{
      this['self'].GetSummary();
    })
  }

  GetSummary() {
    this.getDashboardsDetails();
  }
  ViewAll() {
    this.GenSearchFieldsData.reset();
    this.getDashboardsDetails();
  }
  SearchClear() {
    this.GenSearchFieldsData.reset();
  }
  AdvanceSearch() { 
    this.getDashboardsDetails();
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.analyticsService);
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  // onRowDoubleClicked(event) {
  //   const modalRef = this['self'].modalService.open(ProductViewModalComponent, {
  //     backdrop: false,
  //     keyboard: false,
  //     windowClass: 'modal-lg right modal-right',
  //     animation: true
  //   });
  //   modalRef.componentInstance.Content={
  //     heading: 'View',
  //     content: { id: event.data['ID'] }
  //   }
  // }


}
